import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { UiComponentsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { DirectiveModule } from '@fcom/common/directives';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';

import { FormErrorFocusDirective } from './directives/form-error-focus.directive';
import { CommonServiceFormsModule } from './components/common/common-service-forms.module';
import { RadioListComponent } from './components/radio-list/radio-list.component';
import { DirectMarketingPreferencesFormComponent } from './components/direct-marketing-preferences-form.component';
import { SubmitService, PrefillService, PhonePrefixService } from './services';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    GtmModule,
    PipesModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    CommonServiceFormsModule,
    UiComponentsModule,
    UiTranslateModule,
  ],
  declarations: [FormErrorFocusDirective, RadioListComponent, DirectMarketingPreferencesFormComponent],
  exports: [FormErrorFocusDirective, RadioListComponent, DirectMarketingPreferencesFormComponent],
  providers: [FormErrorFocusDirective, SubmitService, PrefillService, PhonePrefixService],
})
export class ServiceFormsModule {}
